import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  // {
  //   path: "/transaction",
  //   name: authCodeMap.transaction,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/transaction/goodsManagement",
  //   meta: {
  //     title: "交易",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.transaction,
  //   },
  //   children: [
  //     {
  //       path: "goodsManagement",
  //       name: authCodeMap.transaction_goods_management,
  //       component: (): any => import("@/modules/transaction/pages/goodsManagement/index.vue"),
  //       meta: {
  //         title: "交易_商品管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.transaction_goods_management,
  //       },
  //     },
  //     {
  //       path: "clueManagement",
  //       name: authCodeMap.transaction_clue_management,
  //       component: (): any => import("@/modules/transaction/pages/clueManagement/ClueManagementPage.vue"),
  //       meta: {
  //         title: "交易_线索管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.transaction_clue_management,
  //       },
  //     },
  //     {
  //       path: "consumptionManagement",
  //       name: authCodeMap.transaction_consumption_management,
  //       component: (): any => import("@/modules/transaction/pages/consumptionManagement/consumptionManagementPage.vue"),
  //       meta: {
  //         title: "交易_消费管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.transaction_consumption_management,
  //       },
  //     },
  //     {
  //       path: "clueManagement/detail/:id",
  //       name: authCodeMap.transaction_clue_management_detail,
  //       component: (): any => import("@/modules/transaction/pages/clueManagement/detail.vue"),
  //       meta: {
  //         title: "交易_线索管理_详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.transaction_clue_management_detail,
  //       },
  //     },
  //     {
  //       path: "goodsManagement/edit",
  //       name: "transaction_goods_management_edit",
  //       component: (): any => import("@/modules/transaction/pages/goodsManagement/edit/index.vue"),
  //       meta: {
  //         title: "交易_商品管理_编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: "transaction_goods_management_edit",
  //       },
  //     },
  //     {
  //       path: "orderRecord",
  //       name: authCodeMap.order_record,
  //       component: (): any => import("@/modules/transaction/pages/orderRecord/index.vue"),
  //       meta: {
  //         title: "营销_邀约管理_订单记录",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.order_record,
  //       },
  //     },
  //   ],
  // },
];
export default routes;
